<!-- eslint-disable no-nested-ternary -->
<template>
  <li v-if="shouldRenderMessage" :id="`li-${data.id}`" :class="alignBubble">
    <div v-if="!isInteractive" :id="`wrap-${data.id}`" :class="wrapClass">
      <div v-if="isIncoming" class="sender--info">
        <woot-thumbnail
          :src="sender.thumbnail"
          :username="senderNameForAvatar"
          size="32px"
        />
        <a
          v-if="isATweet && isIncoming"
          class="sender--available-name"
          :href="twitterProfileLink"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {{ sender.name }}
        </a>
      </div>
      <div v-if="isFailed" class="message-failed--alert">
        <woot-button
          v-tooltip.top-end="$t('CONVERSATION.TRY_AGAIN')"
          size="tiny"
          color-scheme="alert"
          variant="clear"
          icon="arrow-clockwise"
          @click="retrySendMessage"
        />
      </div>
      <div
        :id="'conversation-' + id"
        v-tooltip.top-start="messageToolTip"
        :class="bubbleClass"
      >
        <div v-if="shouldShowHeader" class="whatsapp-member-header">
          <span :style="whatsappMemberHeaderStyle">{{ senderName }}</span>
          <span :style="senderPhoneStyle">
            {{
              senderPhoneNumber && senderPhoneNumber != senderName
                ? senderPhoneNumber
                : ''
            }}
          </span>
        </div>
        <bubble-call
          v-if="isCallMessage"
          :message-id="id"
          :conversation-id="conversationId"
          :content-attributes="contentAttributes"
          :message-content-type="data.content_type"
          :message-type="data.message_type"
          :attachments="data.attachments"
          :inbox-id="data.inbox_id.toString()"
        />
        <bubble-integration
          :message-id="data.id"
          :content-attributes="contentAttributes"
          :inbox-id="data.inbox_id"
        />
        <div
          class="wrapper__d-flex-column"
          :style="{ 'padding-bottom': contentWrapperPadding }"
        >
          <bubble-mail-head
            :email-attributes="contentAttributes.email"
            :cc="emailHeadAttributes.cc"
            :bcc="emailHeadAttributes.bcc"
            :is-incoming="isIncoming"
          />
          <bubble-reply-to
            v-if="
              (inReplyToMessageId || hasUnresolvedReply) &&
                inboxSupportsReplyTo.incoming
            "
            :message="inReplyToMessage"
            :message-type="data.message_type"
            :parent-has-attachments="hasAttachments"
          />
          <span
            v-if="isPending && hasAttachments"
            class="chat-bubble has-attachment agent"
          >
            {{ $t('CONVERSATION.UPLOADING_ATTACHMENTS') }}
          </span>
          <div
            v-if="!isPending && hasAttachments && !isCallMessage"
            class="wrapper__d-flex-column"
          >
            <div v-for="attachment in data.attachments" :key="attachment.id">
              <bubble-image
                v-if="attachment.file_type === 'image' && !hasImageError"
                :id="id"
                :url="attachment.data_url"
                :is-incoming="isIncoming"
                :is-private="data.private"
                @error="onImageLoadError"
                @load="onLoaded"
              />
              <div
                v-else-if="attachment.file_type === 'audio'"
                class="audio-section message-text__wrap"
              >
                <custom-audio
                  :message-id="id"
                  :source="attachment.data_url"
                  :is-incoming="isIncoming"
                  :is-private="data.private"
                />
              </div>
              <bubble-video
                v-else-if="attachment.file_type === 'video'"
                :id="id"
                :url="attachment.data_url"
                :is-private="data.private"
                :message-type="data.message_type"
                :message-status="status"
                :source-id="data.source_id"
                :inbox-id="data.inbox_id"
                :created-at="createdAt"
              />
              <bubble-location
                v-else-if="attachment.file_type === 'location'"
                :latitude="attachment.coordinates_lat"
                :longitude="attachment.coordinates_long"
                :name="attachment.fallback_title"
              />
              <bubble-contact
                v-else-if="attachment.file_type === 'contact'"
                :name="data.content"
                :phone-number="attachment.fallback_title"
              />
              <instagram-image-error-placeholder
                v-else-if="hasImageError && hasInstagramStory"
              />
              <bubble-fallback
                v-else-if="
                  attachment.file_type === 'fallback' && message === ''
                "
                :message="attachment.fallback_title"
                :url="attachment.data_url"
                :channel-type="channelType"
                :has-instagram-story="hasInstagramStory"
              />
              <bubble-file
                v-else-if="attachment.file_type !== 'fallback'"
                :id="id"
                :url="attachment.data_url"
                @error="onImageLoadError"
                @load="onLoaded"
              />
              <div
                v-if="hasIgPostCaption(attachment)"
                class="ig-post-title message-text__wrap"
              >
                {{ attachment.fallback_title }}
              </div>
            </div>
          </div>
          <bubble-contact-custom
            v-if="isContactMessage && !isPending"
            :content-attributes="contentAttributes"
          />
          <p
            v-if="contentAttributes.header && !isFacebookTemplate"
            class="template-header"
          >
            {{ contentAttributes.header }}
          </p>
          <bubble-text
            v-if="
              (data.content &&
                !hasItemsInContentAttributes &&
                !isPollMessage) ||
                (isAnUnsupportedMessage && !isPollMessage) ||
                (isUnsupported && !isPollMessage)
            "
            :is-a-whatsapp-channel="isAWhatsappChannel"
            :message="message"
            :reply-to="isReply"
            :is-email="isEmailContentType"
            :display-quoted-button="displayQuotedButton"
          />
          <bubble-poll
            v-if="isPollMessage"
            :question="pollData.question"
            :options="pollData.options"
          />
        </div>
        <bubble-actions
          :id="data.id"
          :sender="data.sender"
          :story-sender="storySender"
          :story-id="storyId"
          :is-a-tweet="isATweet"
          :is-a-whatsapp-channel="isAWhatsappChannel"
          :has-instagram-story="hasInstagramStory"
          :is-email="isEmailContentType"
          :is-private="data.private"
          :message-type="data.message_type"
          :message-status="status"
          :source-id="data.source_id"
          :inbox-id="data.inbox_id"
          :created-at="createdAt"
        />
      </div>
      <woot-modal
        v-if="showTranslateModal"
        modal-type="right-aligned"
        show
        :on-close="onCloseTranslateModal"
      >
        <div class="column content">
          <p>
            <b>{{ $t('TRANSLATE_MODAL.ORIGINAL_CONTENT') }}</b>
          </p>
          <p v-dompurify-html="data.content" />
          <br />
          <hr />
          <div v-if="translationsAvailable">
            <p>
              <b>{{ $t('TRANSLATE_MODAL.TRANSLATED_CONTENT') }}</b>
            </p>
            <div
              v-for="(translation, language) in translations"
              :key="language"
            >
              <p>
                <strong>{{ language }}:</strong>
              </p>
              <p v-dompurify-html="translation" />
              <br />
            </div>
          </div>
          <p v-else>
            {{ $t('TRANSLATE_MODAL.NO_TRANSLATIONS_AVAILABLE') }}
          </p>
        </div>
      </woot-modal>
      <spinner v-if="isPending" size="tiny" />
      <div v-if="showAvatar" class="sender--info">
        <woot-thumbnail
          :src="sender.thumbnail"
          :username="senderNameForAvatar"
          size="32px"
        />
        <a
          v-if="isATweet && isIncoming"
          class="sender--available-name"
          :href="twitterProfileLink"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          {{ sender.name }}
        </a>
      </div>
    </div>
    <div v-else :class="wrapClass">
      <div class="interactive-buttons-container">
        <div
          :id="'conversation-' + id"
          v-tooltip.top-start="messageToolTip"
          :class="bubbleClass"
        >
          <div
            class="wrapper__d-flex-column"
            :style="{ 'padding-bottom': contentWrapperPadding }"
          >
            <p
              v-if="contentAttributes.header && !isFacebookTemplate"
              class="template-header"
            >
              {{ contentAttributes.header }}
            </p>
            <div class="message-text__wrap">
              <div v-dompurify-html="message" class="text-content" />
            </div>
          </div>
          <bubble-actions
            :id="data.id"
            :sender="data.sender"
            :story-sender="storySender"
            :story-id="storyId"
            :is-a-tweet="isATweet"
            :is-a-whatsapp-channel="isAWhatsappChannel"
            :has-instagram-story="hasInstagramStory"
            :is-email="isEmailContentType"
            :is-private="data.private"
            :message-type="data.message_type"
            :message-status="status"
            :source-id="data.source_id"
            :inbox-id="data.inbox_id"
            :created-at="createdAt"
          />
        </div>
        <bubble-interactive-buttons
          v-if="isInteractiveButtons && !isFacebookTemplate"
          :message="message"
          :content-attributes="contentAttributes"
        />
        <bubble-interactive-list
          v-else-if="isInteractiveList && !isFacebookTemplate"
          :message="message"
          :content-attributes="contentAttributes"
        />
      </div>
      <div v-if="showAvatar" class="sender--info">
        <woot-thumbnail
          :src="sender.thumbnail"
          :username="senderNameForAvatar"
          size="32px"
        />
      </div>
    </div>
    <div v-if="shouldShowContextMenu" class="context-menu-wrap">
      <div v-if="shouldShowMenu">
        <context-menu
          v-if="isBubble && !isMessageDeleted"
          :is-open="showContextMenu"
          :show-copy="hasText"
          :show-reply-to="showReplyTo"
          :show-delete="hasText || hasAttachments"
          :show-canned-response-option="isOutgoing && hasText"
          :menu-position="contextMenuPosition"
          :message-content="data.content"
          :message-id="data.id"
          @toggle="handleContextMenuClick"
          @delete="handleDelete"
          @translate="handleTranslate"
          @reply-to="handleReplyTo"
        />
      </div>
    </div>
  </li>
</template>
<script>
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import BubbleActions from './bubble/Actions';
import BubbleFile from './bubble/File';
import BubbleImage from './bubble/Image';
import BubbleIntegration from './bubble/Integration.vue';
import BubbleLocation from './bubble/Location';
import BubbleMailHead from './bubble/MailHead';
import BubbleText from './bubble/Text';
import BubbleVideo from './bubble/Video.vue';
import BubbleContact from './bubble/Contact';
import BubbleContactCustom from './bubble/ContactCustom';
import BubbleCall from './bubble/Call';
import BubbleFallback from './bubble/Fallback';
import BubbleReplyTo from './bubble/ReplyTo.vue';
import BubbleInteractiveButtons from './bubble/InteractiveButtons.vue';
import BubbleInteractiveList from './bubble/InteractiveList.vue';
import BubblePoll from './bubble/Poll.vue';
import Spinner from 'shared/components/Spinner';
import ContextMenu from 'dashboard/modules/conversations/components/MessageContextMenu';
import instagramImageErrorPlaceholder from './instagramImageErrorPlaceholder.vue';
import alertMixin from 'shared/mixins/alertMixin';
import contentTypeMixin from 'shared/mixins/contentTypeMixin';
import { INBOX_TYPES } from 'shared/mixins/inboxMixin';
import { isAWhatsAppLineChannel } from 'dashboard/helper/messageHelper';
import { MESSAGE_TYPE, MESSAGE_STATUS } from 'shared/constants/messages';
import { generateBotMessageContent } from './helpers/botMessageContentHelper';
import {
  buildTemplateRetryPayload,
  isFacebookTemplateMessage,
} from 'dashboard/helper/messengerTemplateHelper';
import { hasVisibleAttachments } from 'dashboard/helper/messageHelper';
import { mapGetters } from 'vuex';
import { getUrlExtension } from '../../../../shared/constants/messages';
import { CALL_TYPES } from 'widget/helpers/constants';
import CustomAudio from './CustomAudio.vue';
import {
  LocalStorage,
  LOCAL_STORAGE_KEYS,
} from 'dashboard/helper/localStorage';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  components: {
    BubbleActions,
    BubbleFile,
    BubbleImage,
    BubbleIntegration,
    BubbleLocation,
    BubbleMailHead,
    BubbleText,
    BubbleVideo,
    BubbleContact,
    BubbleContactCustom,
    BubbleCall,
    BubbleFallback,
    ContextMenu,
    Spinner,
    instagramImageErrorPlaceholder,
    BubbleReplyTo,
    BubbleInteractiveButtons,
    BubbleInteractiveList,
    BubblePoll,
    CustomAudio,
  },
  mixins: [alertMixin, messageFormatterMixin, contentTypeMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    createdAtBubble: {
      type: String,
      default: '',
    },
    isATweet: {
      type: Boolean,
      default: false,
    },
    isAWhatsappChannel: {
      type: Boolean,
      default: false,
    },
    hasInstagramStory: {
      type: Boolean,
      default: false,
    },
    isWebWidgetInbox: {
      type: Boolean,
      default: false,
    },
    inboxSupportsReplyTo: {
      type: Object,
      default: () => ({}),
    },
    inReplyTo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showContextMenu: false,
      hasImageError: false,
      showTranslateModal: false,
      id: this.data.id.toString(),
      conversationId: this.data.conversation_id.toString(),
      isAnEvolutionApiWhatsAppChannel: false,
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentAccountId: 'getCurrentAccountId',
      currentChat: 'getSelectedChat',
      currentUser: 'getCurrentUser',
    }),
    /** Indica si el chat actual es un grupo. */
    isGroupChat() {
      return typeof this.currentChat.is_group === 'boolean'
        ? this.currentChat.is_group
        : null;
    },
    /** Indica si trae el inbox id en la data. */
    hasInboxId() {
      return this.data.inbox_id != null;
    },
    /** Determina si se debe mostrar el encabezado del mensaje. */
    shouldShowHeader() {
      const {
        isCurrentUserSender,
        isIntertelUcInbox,
        isGroupChat,
        data: { message_type },
      } = this;

      const isNotCurrentUserSender = !isCurrentUserSender;
      const isNotIntertelUcInbox = !isIntertelUcInbox;
      const isNotMessageTypeZero = message_type !== 0;

      // Retorna true si no es el remitente actual, no es IntertelUc y es grupo
      // o si no es grupo y el tipo de mensaje no es 0
      return (
        this.hasInboxId &&
        isNotCurrentUserSender &&
        isNotIntertelUcInbox &&
        (isGroupChat === true || (isGroupChat !== true && isNotMessageTypeZero))
      );
    },
    // Obtiene el canal actual del chat.
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.data.inbox_id);
    },
    /** Retorna el color del remitente o '#000' si no está definido, usando 'unknown_user' para sender nulo. */
    senderColor() {
      const sender = this.data.sender;
      const participantsColors = this.currentChat.participants_colors;

      if (!participantsColors) return '#000';
      const participantKey = sender
        ? `${
            sender.type?.toLowerCase() === 'agent_bot'
              ? 'agentbot'
              : sender.type?.toLowerCase()
          }_${sender.id}`
        : 'unknown_user';
      return participantsColors[participantKey] || '#000';
    },

    /** Determina si el usuario actual es el remitente del mensaje. */
    isCurrentUserSender() {
      return (
        this.currentUser &&
        this.data.sender &&
        this.currentUser.id === this.data.sender.id
      );
    },
    /** Retorna true si el canal actual es del tipo INTERTEL_UC. */
    isIntertelUcInbox() {
      return this.channelType === INBOX_TYPES.INTERTEL_UC;
    },
    /** Define estilos para el header de los mensajes de WhatsApp (nombre y color). */
    whatsappMemberHeaderStyle() {
      return {
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0px',
        color: this.senderColor,
      };
    },
    /** Define estilos para el número de teléfono del remitente. */
    senderPhoneStyle() {
      return {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0px',
        color: this.senderColor,
      };
    },
    /** Obtiene el número de teléfono del remitente. */
    senderPhoneNumber() {
      const { phone_number = null } = this.sender || {};
      return phone_number;
    },
    channelType() {
      // La informacion del canal se puede obtener de estas dos formas, depende el mensaje ya existe o si recien se creo el objeto tiene una estructura distinta
      return this.currentChat?.meta?.channel || this.currentChat?.channel;
    },
    /**
     * Comprueba si el mensaje actual es una respuesta a otro mensaje.
     * @returns {boolean} - true si el mensaje es una respuesta, false de lo contrario.
     */
    isReply() {
      // Comprueba si existe un ID en el mensaje al que se está respondiendo.
      return !!this.data.content_attributes?.in_reply_to;
    },

    /**
     * Determina si se debe mostrar la opción de responder.
     * La opción de responder solo se muestra si la burbuja no es privada y es un canal de WhatsApp.
     *
     * @returns {boolean} `true` si no es privada, no es evolution api y es un canal de WhatsApp, de lo contrario `false`.
     */
    showReplyTo() {
      return !this.data.private && this.isAWhatsappChannel;
    },
    /**
     * Determina si hay elementos en el atributo de contenido.
     * @returns {boolean} - Verdadero si hay elementos en el atributo de contenido, falso en caso contrario.
     */
    hasItemsInContentAttributes() {
      return (
        this.contentAttributes.items && this.contentAttributes.items.length > 0
      );
    },
    /**
     * Determina si es un mensaje interactivo
     */
    isInteractive() {
      return this.contentAttributes.items;
    },
    /**
     * Determina si es un mensaje interactivo de botones
     */
    isInteractiveButtons() {
      return (
        this.contentAttributes.items && this.contentAttributes.items.length <= 3
      );
    },
    /**
     * Determina si es un mensaje interactivo de Lista
     */
    isInteractiveList() {
      return (
        this.contentAttributes.items && this.contentAttributes.items.length > 3
      );
    },
    /**
     * Determina si se debe renderizar el mensaje actual basado en varias condiciones:
     * - Si el mensaje tiene archivos adjuntos.
     * - Si el mensaje tiene contenido de texto.
     * - Si el mensaje es de tipo correo electrónico.
     * - Si el mensaje es de tipo integración con otra plataforma.
     * - Si el mensaje es de tipo llamada (ya sea llamada perdida o llamada realizada).
     *
     * @returns {boolean} `true` si se debe renderizar el mensaje, de lo contrario, devuelve `false`.
     */
    shouldRenderMessage() {
      return (
        this.hasAttachments ||
        this.data.content ||
        this.isEmailContentType ||
        this.isAnIntegrationMessage ||
        this.isCallMessage ||
        this.hasItemsInContentAttributes ||
        this.isAnUnsupportedMessage ||
        this.isUnsupported ||
        this.isPollMessage ||
        this.isContactMessage
      );
    },
    currentAgentName() {
      return this.$store.getters.getCurrentUser?.name;
    },
    emailMessageContent() {
      const {
        html_content: { full: fullHTMLContent } = {},
        text_content: { full: fullTextContent } = {},
      } = this.contentAttributes.email || {};
      return fullHTMLContent || fullTextContent || '';
    },
    translations() {
      return this.contentAttributes.translations || {};
    },
    displayQuotedButton() {
      if (!this.isIncoming) {
        return false;
      }

      if (this.emailMessageContent.includes('<blockquote')) {
        return true;
      }

      return false;
    },
    translationsAvailable() {
      return !!Object.keys(this.translations).length;
    },
    contentWrapperPadding() {
      if (
        (this.hasText &&
          (this.hasMediaAttachment('video') ||
            this.hasMediaAttachment('image'))) ||
        this.hasText ||
        this.hasIgPostTitle
      )
        return '18px';

      if (
        (this.hasMediaAttachment('video') &&
          getUrlExtension(this.data?.attachments[0]?.data_url) !== 'ogx') ||
        this.hasMediaAttachment('image')
      )
        return 0;

      if (this.hasAttachments || this.isCallMessage) return '24px';
      return 0;
    },
    /**
     * Obtiene el ID del mensaje al que se está respondiendo, si está presente.
     * @returns {string | undefined} - El ID del mensaje al que se está respondiendo, o undefined si no está presente.
     */
    inReplyToMessageId() {
      return this.data.content_attributes?.in_reply_to;
    },
    /**
     * Indica que el mensaje respondió a otro que no se pudo identificar: hay referencia
     * externa pero sin mensaje interno resuelto. Dispara la cita "Mensaje no disponible".
     */
    hasUnresolvedReply() {
      return (
        !!this.data.content_attributes?.in_reply_to_external_id &&
        !this.inReplyToMessageId
      );
    },
    /**
     * Mensaje que se pasa a la burbuja de cita. Para una cita sin resolver se construye un
     * mensaje sintético solo con el autor citado (guardado por el backend desde context.from),
     * para que MessagePreview renderice nombre + "Mensaje no disponible".
     */
    inReplyToMessage() {
      if (!this.hasUnresolvedReply) return this.inReplyTo;

      const senderName = this.data.content_attributes?.in_reply_to_sender_name;
      return senderName ? { sender: { name: senderName } } : {};
    },
    message() {
      if (this.contentType === 'input_csat') {
        return this.$t('CONVERSATION.CSAT_REPLY_MESSAGE');
      }

      if (this.contentType === 'unsupported') {
        return this.$t('CONVERSATION.NO_SUPPORTED_MESSAGE', {
          channel: this.getInboxName(this.channelType),
        });
      }

      // Si es un mensaje de actividad, se maneja de forma especial
      if (this.isActivityMessage) {
        switch (this.data.content) {
          case 'CONVERSATION.GROUP_MEMBERS.ADD_MEMBER':
          case 'CONVERSATION.GROUP_MEMBERS.REMOVE_MEMBER':
            return this.$t(this.data.content, {
              memberName: this.contentAttributes?.member_name,
            });
          case 'CONVERSATION.GROUP_MEMBERS.ADD_MEMBERS':
          case 'CONVERSATION.GROUP_MEMBERS.REMOVE_MEMBERS':
            return this.$t(this.data.content, {
              count: this.contentAttributes?.count,
              memberNames: this.contentAttributes?.member_names,
            });
          default:
            return this.data.content;
        }
      }

      // If the message is an email, emailMessageContent would be present
      // In that case, we would use letter package to render the email
      if (this.emailMessageContent && this.isIncoming) {
        return this.emailMessageContent;
      }

      const messageContent =
        // eslint-disable-next-line no-nested-ternary
        this.isAnUnsupportedMessage && !this.isPending
          ? this.hasInstagramStory
            ? this.$t('CONVERSATION.NO_SUPPORTED_MESSAGE', {
                channel: 'Instagram',
              })
            : this.$t('CHAT_LIST.NO_CONTENT')
          : this.data.content;

      const botMessageContent = generateBotMessageContent(
        this.contentType,
        this.contentAttributes,
        {
          noResponseText: this.$t('CONVERSATION.NO_RESPONSE'),
          csat: {
            ratingTitle: this.$t('CONVERSATION.RATING_TITLE'),
            feedbackTitle: this.$t('CONVERSATION.FEEDBACK_TITLE'),
          },
        }
      );

      const isSendByBot =
        this.data.sender?.type?.toLowerCase() === 'agent_bot' ||
        this.data.content_attributes?.sent_by_bot;
      return (
        this.formatMessage(
          messageContent,
          this.isATweet,
          this.data.private,
          this.isAWhatsappChannel,
          isSendByBot
        ) + botMessageContent
      );
    },
    contentAttributes() {
      return this.data.content_attributes || {};
    },
    sender() {
      return this.data.sender || {};
    },
    // devuelve los datos del customSender
    customSender() {
      return this.data.content_attributes?.custom_sender || {};
    },
    status() {
      return this.data.status;
    },
    storySender() {
      return this.contentAttributes.story_sender || null;
    },
    storyId() {
      return this.contentAttributes.story_id || null;
    },
    contentType() {
      const { content_type: contentType } = this.data;
      return contentType;
    },
    twitterProfileLink() {
      const additionalAttributes = this.sender.additional_attributes || {};
      const { screen_name: screenName } = additionalAttributes;
      return `https://twitter.com/${screenName}`;
    },
    alignBubble() {
      const { message_type: messageType } = this.data;
      const isCentered = messageType === MESSAGE_TYPE.ACTIVITY;
      const isLeftAligned = messageType === MESSAGE_TYPE.INCOMING;
      const isRightAligned =
        messageType === MESSAGE_TYPE.OUTGOING ||
        messageType === MESSAGE_TYPE.TEMPLATE;

      return {
        center: isCentered,
        left: isLeftAligned,
        right: isRightAligned,
        'has-context-menu': this.showContextMenu,
        'has-tweet-menu': this.isATweet,
      };
    },
    createdAt() {
      return this.contentAttributes.external_created_at || this.data.created_at;
    },
    isBubble() {
      return [0, 1, 3].includes(this.data.message_type);
    },
    isIncoming() {
      return this.data.message_type === MESSAGE_TYPE.INCOMING;
    },
    isOutgoing() {
      return this.data.message_type === MESSAGE_TYPE.OUTGOING;
    },
    isTemplate() {
      return this.data.message_type === MESSAGE_TYPE.TEMPLATE;
    },
    // Comprueba si el canal del mensaje es de Facebook.
    isAFacebookChannel() {
      return this.channelType === INBOX_TYPES.FB;
    },
    // Plantilla enviada en un canal de Facebook Messenger: se detecta por la presencia de
    // template_params (mismo marcador que usa WhatsApp). Por ahora se ocultan el header y
    // los botones en la UI, aunque viajen en los datos (CON-2838, criterio 5).
    isFacebookTemplate() {
      return (
        isFacebookTemplateMessage({
          message: this.data,
          isFacebookInbox: this.isAFacebookChannel,
        }) && !this.hasInstagramStory
      );
    },
    isAnIntegrationMessage() {
      return this.contentType === 'integrations';
    },
    // Comprueba si el tipo de contenido es de un mensaje no soportado
    isUnsupported() {
      return this.contentType === 'unsupported';
    },
    // Trata el mensaje como no soportado cuando llega sin contenido para mostrar y no es de un canal de IntertelUC
    isAnUnsupportedMessage() {
      return (
        !this.isCallMessage &&
        !this.hasAttachments &&
        !this.isContactMessage &&
        this.data.content === null
      );
    },
    /**
     * Comprueba si el mensaje actual es de tipo llamada (ya sea llamada perdida o llamada realizada).
     *
     * @returns {boolean} `true` si el mensaje es de tipo llamada, de lo contrario, devuelve `false`.
     */
    isCallMessage() {
      return CALL_TYPES.includes(this.contentType);
    },
    /**
     * True si el mensaje es de tipo contacto (content_type 'contact', WhatsApp Cloud nuevo).
     * Los contactos legacy se guardaron como attachments file_type 'contact' (sin content_type),
     * dan false aquí y se siguen pintando con Contact.vue. Rutas excluyentes; nada legacy se rompe.
     */
    isContactMessage() {
      return this.contentType === 'contact';
    },
    emailHeadAttributes() {
      return {
        email: this.contentAttributes.email,
        cc: this.contentAttributes.cc_emails,
        bcc: this.contentAttributes.bcc_emails,
      };
    },
    hasAttachments() {
      return hasVisibleAttachments(this.data);
    },
    hasExtensionFile() {
      return this.hasAttachments
        ? getUrlExtension(this.data.attachments[0].data_url)
        : null;
    },
    isApplyContentMenu() {
      return !!(
        this.hasAttachments &&
        ['location', 'contact'].includes(this.data.attachments[0].file_type)
      );
    },
    isMessageDeleted() {
      return this.contentAttributes.deleted;
    },
    hasText() {
      /*
      Se utilizó esta comparación en el método con el fin de garantizar que se agrege la clase CSS "is-text" a la burbuja de mensaje en caso de que sea
      un mensaje no soportado. Este comportamiento es necesario porque en caso de ser un mensaje no soportado se debe mostrar un texto informativo en la burbuja
      y para que guarde la distancia con la fecha que se muesta al final de la burbuja es necesario que tenga aplicada la clase CSS "is-text"
      */
      return !!this.data.content || this.isAnUnsupportedMessage;
    },
    /*
    Indica si el mensaje es un ig_post de Instagram DM que trae título (caption).
    Solo aplica a conversaciones de Instagram (hasInstagramStory) y a adjuntos con
    fallback_title cuyo file_type sea uno de los tipos a los que el backend convierte
    un ig_post (image, video o file). Se usa para que la burbuja reciba el layout de
    "texto + adjunto" (clase is-text + padding inferior) y la fecha/hora quede debajo
    del media en vez de encima.
    */
    hasIgPostTitle() {
      return (this.data.attachments || []).some(attachment =>
        this.hasIgPostCaption(attachment)
      );
    },
    messageToolTip() {
      if (this.isMessageDeleted) {
        return false;
      }
      if (this.isFailed) {
        return this.$t(`CONVERSATION.SEND_FAILED`);
      }
      return false;
    },
    /**
     * Devuelve un objeto que representa las clases CSS que se aplicarán al elemento de la conversación actual.
     * @returns {Object} Objeto con las clases CSS a aplicar.
     * - Si `isBubble` es verdadero, incluirá la clase "wrap".
     * - Si `isBubble` es falso, incluirá la clase "activity-wrap".
     * - Si `isPending` es verdadero, incluirá la clase "is-pending".
     * - Si `isFailed` es verdadero, incluirá la clase "is-failed".
     * - Si `isEmailContentType` es verdadero, incluirá la clase "is-email".
     * - Si `isCallMessage` es verdadero, incluirá la clase "is-call".
     */
    wrapClass() {
      return {
        wrap: this.isBubble,
        'activity-wrap': !this.isBubble,
        'is-pending': this.isPending,
        'is-failed': this.isFailed,
        'is-email': this.isEmailContentType,
        'is-call': this.isCallMessage,
      };
    },
    /**
     * Devuelve un objeto que representa las clases CSS que se aplicarán a la burbuja del mensaje actual.
     * @returns {Object} Objeto con las clases CSS a aplicar.
     * - Si `isBubble` es verdadero, incluirá la clase "bubble".
     * - Si `data.private` es verdadero, incluirá la clase "is-private".
     * - Si tiene un archivo adjunto de imagen, incluirá la clase "is-image".
     * - Si tiene un archivo adjunto de video, incluirá la clase "is-video".
     * - Si tiene un archivo adjunto de audio, incluirá la clase "is-audio".
     * - Si `hasText` es verdadero, incluirá la clase "is-text".
     * - Si `isSentByBot` es verdadero, incluirá la clase "is-from-bot".
     * - Si `isFailed` es verdadero, incluirá la clase "is-failed".
     * - Si `isEmailContentType` es verdadero, incluirá la clase "is-email".
     * - Si `isCallMessage` es verdadero, incluirá la clase "is-call".
     */
    bubbleClass() {
      return {
        bubble: this.isBubble,
        'is-private': this.data.private,
        'is-image': this.hasMediaAttachment('image'),
        'is-video': this.hasMediaAttachment('video'),
        'is-audio': this.hasMediaAttachment('audio'),
        'is-text': this.hasText || this.hasIgPostTitle,
        'is-from-bot': this.isSentByBot,
        'is-failed': this.isFailed,
        'is-email': this.isEmailContentType,
        'is-call': this.isCallMessage,
        'is-response': this.inReplyToMessageId,
        'is-poll': this.isPollMessage,
      };
    },
    isPending() {
      return this.data.status === MESSAGE_STATUS.PROGRESS;
    },
    isFailed() {
      /**
       * Si el envio del mensaje falla solo se muestra la opcion para reintentar el envvio en los siguientes casos:
       *
       * 1. Si no es un canal de Evolution API
       * 2. Es un canal de Evolution API y tiene habilitado el envio de mensajes
       *
       * En caso de haber fallado siendo un canal de Evolution API con el envio de mensajes inhabilitado es porque no
       * esta permitido el envio y en consecuencia el mensajes se debe borrar en el proximo refresh de la pagina, por
       * esa razon es que no se muestra la opcion para reintentar el evnio del mensaje
       */
      if (
        !this.isAnEvolutionApiWhatsAppChannel ||
        (this.isAnEvolutionApiWhatsAppChannel && this.currentChat.can_reply)
      )
        return this.data.status === MESSAGE_STATUS.FAILED;
      return false;
    },
    /**
     * Se concidera que fue enviado por el Bot cuando no tiene un nombre asignado en el customSender
     * y no tiene tipo asignado en el sender o en caso de tenerlo es de tipo'agent_bot'
     * */
    isSentByBot() {
      if (this.isPending || this.isFailed) return false;
      return (
        !this.customSender.name &&
        (!this.sender.type || this.sender.type === 'agent_bot')
      );
    },
    contextMenuPosition() {
      const { message_type: messageType } = this.data;
      return messageType ? 'right' : 'left';
    },
    shouldShowContextMenu() {
      return !(this.isFailed || this.isPending);
    },
    shouldShowMenu() {
      return (
        this.hasText ||
        (!this.hasText && this.hasAttachments && this.isAWhatsappChannel) ||
        this.isApplyContentMenu
      );
    },
    errorMessage() {
      const { meta } = this.data;
      return meta ? meta.error : '';
    },
    showAvatar() {
      if (this.isOutgoing || this.isTemplate) {
        return true;
      }
      return this.isATweet && this.isIncoming && this.sender;
    },
    // Obtiene el nombre del remitente del mensaje.
    senderName() {
      if (this.isOutgoing || this.isTemplate) {
        /* Coloca el prefijo Bot_ en el nombre si es un bot externo */
        let { name } = this.sender || {};
        /* En caso de que no hubiera habido ningun nombre que estraer de sender, se intenta tomar un nombre de customSender */
        if (!name) {
          name = this.customSender.name;
        }

        if (this.isSentByBot) {
          name = `${this.$t('CONVERSATION.BOT')}`;
        }

        if (this.fromExternalMessage) {
          if (this.isAWhatsAppLineChannel) {
            name = this.inbox.phone_number;
          } else {
            name = this.$t('CONVERSATION.FROM_EXTERNAL_MESSAGE');
          }
        }

        return name;
      }

      const { name = '' } = this.sender || {};
      return name;
    },
    // Obtiene el nombre del remitente del mensaje para el avatar.
    senderNameForAvatar() {
      const name = this.senderName;
      if ((this.isOutgoing || this.isTemplate) && this.fromExternalMessage) {
        if (this.isAWhatsAppLineChannel) {
          return this.inbox.phone_number;
        }

        return '?';
      }

      return name;
    },
    // Canal de línea de WhatsApp (Evolution o Cloud): un mensaje sin sender se atribuye
    // al teléfono de la línea en lugar del label "Mensaje externo", igual que en la vista previa.
    isAWhatsAppLineChannel() {
      return isAWhatsAppLineChannel(this.channelType);
    },
    // Comprueba si el mensaje no tiene un remitente o si es un mensaje externo
    fromExternalMessage() {
      if (
        this.hasInboxId &&
        Object.keys(this.sender).length === 0 &&
        this.channelForExternalMessage
      ) {
        return true;
      }

      return false;
    },
    // Comprueba si el mensaje es de tipo acitividad
    isActivityMessage() {
      return this.data.message_type === MESSAGE_TYPE.ACTIVITY;
    },
    // Comprueba si es un canal en donde permite enviar mensajes externos
    channelForExternalMessage() {
      return (
        this.channelType === INBOX_TYPES.EVOLUTION_API ||
        this.channelType === INBOX_TYPES.WHATSAPP ||
        this.channelType === INBOX_TYPES.FB
      );
    },
    /**
     * Determina si el mensaje es un poll de WhatsApp
     */
    isPollMessage() {
      return this.data.content_type === 'poll';
    },
    /**
     * Extrae los datos del poll del content_attributes
     */
    pollData() {
      if (!this.isPollMessage) {
        return { question: '', options: [] };
      }
      if (this.data.content_attributes?.poll) {
        return this.data.content_attributes.poll;
      }
      return { question: '', options: [] };
    },
  },
  watch: {
    data() {
      this.convertFilesToAttachments();
      this.hasImageError = false;
    },
    async currentChat(newChat) {
      if (
        !newChat.can_reply &&
        this.channelType === INBOX_TYPES.EVOLUTION_API &&
        this.status === MESSAGE_STATUS.FAILED
      ) {
        await this.handleDelete();
      }
    },
  },
  mounted() {
    this.hasImageError = false;
    this.isAnEvolutionApiWhatsAppChannel =
      this.channelType === INBOX_TYPES.EVOLUTION_API;
  },
  methods: {
    /**
     * Convierte `this.data.files` en `this.data.attachments` con los campos necesarios.
     * No realiza ninguna acción si `this.data.files` no existe.
     *
     * @method
     * @returns {void}
     *
     * @property {Object[]} [this.data.files] - Archivos a convertir.
     * @property {Object[]} [this.data.attachments] - Attachments resultantes.
     */
    convertFilesToAttachments() {
      if (this.data.files) {
        this.data.attachments = this.data.files.map(file => ({
          id: file.id || null,
          message_id: this.data.id || null,
          file_type: file.type,
          account_id: null,
          extension: file.name.split('.').pop(),
          data_url: URL.createObjectURL(file),
          thumb_url: URL.createObjectURL(file),
          file_size: file.size,
        }));
      }
    },
    /**
     * Método emitir evento al componente padre avisando que el atachment se ha cargado
     */
    onLoaded() {
      this.$emit('load');
    },
    /**
     * Indica si para un adjunto se debe mostrar el caption (título) de un ig_post.
     * Solo aplica a conversaciones de Instagram DM (hasInstagramStory) y a adjuntos
     * con fallback_title cuyo file_type sea uno de los tipos a los que el backend
     * convierte un ig_post (image, video o file).
     * @param {Object} attachment - Adjunto del mensaje.
     * @returns {boolean}
     */
    hasIgPostCaption(attachment) {
      return (
        this.hasInstagramStory &&
        !!attachment.fallback_title &&
        ['image', 'video', 'file'].includes(attachment.file_type)
      );
    },
    hasMediaAttachment(type) {
      if (this.hasAttachments) {
        // para canales de instagram
        if (
          this.hasInstagramStory &&
          this.data.attachments[0].file_type === 'share'
        ) {
          const images = ['JPEG', 'JPG', 'GIF', 'PNG'];
          const videos = ['MP4', 'GIF', 'MOV'];
          const extension = getUrlExtension(
            this.data.attachments[0].data_url
          ).toUpperCase();
          images.includes(extension)
            ? (this.data.attachments[0].file_type = 'image')
            : videos.includes(extension)
            ? (this.data.attachments[0].file_type = 'video')
            : null;
        }
        const existType = this.data.attachments.find(attachment => {
          const { file_type: fileType } = attachment;
          return fileType === type;
        });
        return existType && !this.hasImageError;
      }
      return false;
    },
    handleContextMenuClick() {
      this.showContextMenu = !this.showContextMenu;
    },
    async handleDelete() {
      const { conversation_id: conversationId, id: messageId } = this.data;
      try {
        await this.$store.dispatch('deleteMessage', {
          conversationId,
          messageId,
          channelType: this.channelType,
          canReply: this.currentChat.can_reply,
        });
        if (
          !this.isAnEvolutionApiWhatsAppChannel ||
          (this.isAnEvolutionApiWhatsAppChannel && this.currentChat.can_reply)
        )
          this.showAlert(this.$t('CONVERSATION.SUCCESS_DELETE_MESSAGE'));
        this.showContextMenu = false;
      } catch (error) {
        if (
          !this.isAnEvolutionApiWhatsAppChannel ||
          (this.isAnEvolutionApiWhatsAppChannel && this.currentChat.can_reply)
        )
          this.showAlert(this.$t('CONVERSATION.FAIL_DELETE_MESSSAGE'));
      }
    },
    /** Reintenta enviar un mensaje con los datos actuales. */
    async retrySendMessage() {
      // Plantillas (FB/WhatsApp): se re-mapea snake_case → camelCase para reenviarlas como plantilla
      // (el resto reintenta con sus datos). Reintentar la plantilla es seguro aunque la ventana se
      // haya reabierto: Meta la acepta. Se construye un objeto nuevo para NO mutar el store de Vuex.
      const payload = buildTemplateRetryPayload(this.data) || {
        ...this.data,
        conversationId: this.data.conversation_id,
      };
      await this.$store.dispatch('sendMessageWithData', payload);
    },
    onImageLoadError() {
      this.hasImageError = true;
    },
    /**
     * Actualiza el almacenamiento local con los datos del mensaje al que se está respondiendo y emite un evento para activar la funcionalidad de "responder a mensaje".
     *
     * @returns {void} No devuelve ningún valor.
     */
    handleReplyTo() {
      const replyStorageKey = LOCAL_STORAGE_KEYS.MESSAGE_REPLY_TO;
      const { conversation_id: conversationId, id: replyTo } = this.data;

      LocalStorage.updateJsonStore(replyStorageKey, conversationId, replyTo);
      bus.$emit(BUS_EVENTS.TOGGLE_REPLY_TO_MESSAGE, this.data);
    },
    handleTranslate() {
      const { locale } = this.getAccount(this.currentAccountId);
      const { conversation_id: conversationId, id: messageId } = this.data;
      this.$store.dispatch('translateMessage', {
        conversationId,
        messageId,
        targetLanguage: locale || 'en',
      });
      this.showTranslateModal = true;
    },
    onCloseTranslateModal() {
      this.showTranslateModal = false;
    },
    // Retorna el nombre del buzón
    getInboxName(channelType) {
      switch (channelType) {
        case INBOX_TYPES.EVOLUTION_API:
          return 'WhatsApp vinculado';
        case INBOX_TYPES.WHATSAPP:
          return 'WhatsApp Cloud API';
        case INBOX_TYPES.FB:
          if (
            this.currentChat.additional_attributes?.type ===
            'instagram_direct_message'
          ) {
            return 'Instagram';
          }

          return 'Facebook';
        default:
          return '';
      }
    },
  },
};
</script>
<style lang="scss">
.ig-post-title {
  box-sizing: border-box;
  max-width: 32rem;
  margin-top: var(--space-smaller);
  padding: var(--space-smaller) var(--space-small);
  font-size: var(--font-size-small);
  line-height: 1.5;
  word-break: break-word;
  white-space: pre-line;
}

.conversation-panel > li.right .bubble.is-call {
  display: grid;
  padding: 12px 16px;
  background: var(--w-50);
  border-radius: 0.8rem;
  border: 1px var(--conversa2-blue-200-color) solid;

  .message-text--metadata .time {
    color: var(--conversa2-neutral-500-color);
    font-size: 1rem;
    font-style: normal;
    font-weight: var(--font-weight-normal);
    line-height: 1.8rem;
  }
}

.conversation-panel > li.right .bubble.is-image.is-text,
.conversation-panel > li.right .bubble.is-video.is-text {
  .message-text--metadata .time {
    color: var(--conversa2-neutral-900-color);
  }
}

.conversation-panel > li.right .bubble.is-text.is-from-bot {
  background: var(--conversa2-blue-50-color);
  border: 1px solid var(--conversa2-blue-200-color);
  color: var(--conversa2-neutral-900-color);
  line-height: var(--space-two);

  &.is-private .message-text--metadata .time {
    color: var(--s-400);
  }

  .message-text__wrap .text-content .link {
    color: var(--conversa2-neutral-800-color);
    text-decoration: none;
  }
  .message-text__wrap .text-content .link:hover {
    color: var(--conversa2-neutral-800-color);
    text-decoration: underline;
  }
}

.conversation-panel > li.left .bubble.bubble.is-call {
  display: grid;
  padding: 12px 16px;
  background: var(--white);
  border-radius: 0.8rem;
  border: 1px var(--conversa2-neutral-100-color) solid;

  .message-text--metadata .time {
    color: var(--conversa2-neutral-400-color);
    font-size: 1rem;
    font-style: normal;
    font-weight: var(--font-weight-normal);
    line-height: 1.8rem;
  }
}

.wrapper__download {
  border-radius: var(--space-smaller);
  padding: var(--space-smaller);
}

.wrapper__d-flex-column {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.file.message-text__wrap {
  display: flex;
  padding: var(--space-small);
  flex-direction: row;
  align-items: center;
  gap: var(--space-one);
  border-radius: var(--space-smaller);
  justify-content: flex-start;
}

li.right .wrap {
  .download.button:hover {
    background-color: rgba(183, 227, 246, 0.6);
  }

  .file.message-text__wrap {
    background-color: var(--conversa2-blue-100-color);
  }

  .is-private {
    .file.message-text__wrap {
      background-color: var(--conversa2-orange-50-color);
    }
    .download.button:hover {
      background-color: var(--conversa2-orange-100-color);
    }
  }

  .message-text__wrap .text-content .link {
    text-decoration: none;
  }

  .message-text__wrap .text-content .link:hover {
    text-decoration: underline;
  }
}

li.left .wrap {
  .download.button:hover {
    background-color: var(--conversa2-neutral-100-color);
  }

  .file.message-text__wrap {
    background-color: var(--conversa2-neutral-50-color);
  }
}

.wrap {
  > .bubble {
    min-width: 140px;

    &.is-image,
    &.is-video {
      overflow: hidden;

      .image,
      .video {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 32rem;
        border-radius: var(--border-radius-normal-small);
        overflow: hidden;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.24);

        > video {
          height: 100%;
          object-fit: cover;
          width: 100%;
        }
      }
      .video {
        height: 18rem;
        min-width: 18rem;
      }
    }

    &.is-audio {
      .audio-section {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &.is-image.is-text > .wrapper__d-flex-column > .message-text__wrap {
      max-width: 32rem;
    }

    &.is-video.is-text > .wrapper__d-flex-column > .message-text__wrap {
      max-width: 32rem;
    }

    &.is-audio.is-text > .wrapper__d-flex-column > .message-text__wrap {
      max-width: 32rem;
    }

    &.is-private {
      .file--icon {
        color: var(--w-400);
      }
      .text-block-title {
        color: var(--color-body);
      }
    }

    &.is-private.is-text > .wrapper__d-flex-column > .message-text__wrap .link {
      color: var(--conversa2-neutral-800-color);
      text-decoration: none;
    }

    &.is-private.is-text
      > .wrapper__d-flex-column
      > .message-text__wrap
      .link:hover {
      color: var(--conversa2-neutral-800-color);
      text-decoration: underline;
    }
    &.is-private.is-text
      > .wrapper__d-flex-column
      > .message-text__wrap
      .prosemirror-mention-node {
      font-weight: var(--font-weight-black);
      background: none;
      border-radius: var(--border-radius-small);
      padding: 0;
      color: var(--color-body);
      text-decoration: underline;
    }

    &.is-failed {
      background: var(--r-200);

      .message-text--metadata .time {
        color: var(--conversa2-neutral-900-color);
      }
    }
  }

  &.is-pending {
    position: relative;
    opacity: 0.8;

    .spinner {
      position: absolute;
      bottom: var(--space-smaller);
      right: var(--space-smaller);
    }

    > .is-image.is-text.bubble > .message-text__wrap {
      padding: 0;
    }
  }
}

.wrap.is-email {
  --bubble-max-width: 84% !important;
}

.sender--info {
  align-items: center;
  color: var(--b-700);
  display: inline-flex;
  padding: var(--space-smaller) 0;

  .sender--available-name {
    font-size: var(--font-size-mini);
    margin-left: var(--space-smaller);
  }
}

.message-failed--alert {
  color: var(--r-900);
  flex-grow: 1;
  text-align: right;
  margin-top: var(--space-smaller) var(--space-smaller) 0 0;
}

.button--delete-message {
  visibility: hidden;
}

li.left,
li.right {
  display: flex;
  align-items: flex-start;

  .context-menu {
    display: none;
  }

  &.has-context-menu .context-menu {
    display: block;
  }

  &:hover {
    &.button--delete-message {
      visibility: visible;
    }
    .context-menu {
      display: block;
    }
  }
}

li.left.has-tweet-menu .context-menu {
  margin-bottom: var(--space-medium);
}

li.right .context-menu-wrap {
  margin-left: auto;
}

li.right {
  flex-direction: row-reverse;
  justify-content: flex-end;

  .wrap.is-pending {
    margin-left: auto;
  }

  .wrap.is-failed {
    display: flex;
    align-items: flex-end;
    margin-left: auto;
  }
}

.has-context-menu {
  background: transparent;
  .button--delete-message {
    visibility: visible;
  }
}

.context-menu {
  position: relative;
}

.interactive-buttons-container {
  min-width: 140px;
  display: flow;
}

.whatsapp-member-header {
  padding-bottom: 4px;
}

.template-header {
  font-weight: var(--font-weight-bold);
  margin-bottom: var(--space-smaller);
}
</style>
